import React, { useEffect, useState } from 'react';
import connect from "react-redux/es/components/connect";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { actionToggleFooter, actionToggleNavBar, actionToggleSideBar } from "../store/action/LayoutActionSupervisor";
import { auth, logInWithEmailAndPassword, getUserDetails } from "./common/FirebaseSupervisor";
import translate from "../i18n/translate";

const LoginSupervisor = (props) => {
    const [email, setEmail] = useState(process.env.REACT_APP_LOGINNAME ? process.env.REACT_APP_LOGINNAME : "");
    const [password, setPassword] = useState(process.env.REACT_APP_PASSWORD ? process.env.REACT_APP_PASSWORD : "");
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [user, loading, error] = useAuthState(auth);
    const navigate = useNavigate();

    const validate = async () => {
        if (!email) {
            alert('Please enter your email');
            return;
        }
        if (!password) {
            alert('Please enter your password');
            return;
        }
        if (user === null || user?.emailVerified) {
            setIsButtonClicked(true);
            const response = await logInWithEmailAndPassword(email, password);
            if (response === 1) {
                navigate("/dashboard");
            } else if (response === 11) {
                navigate("/passwordchange?Reset=1");
            } else if (response === 2 || response === 12) {
                navigate("/supervisorotp?RID=" + response);
            } else {
                setIsButtonClicked(false);
            }
        }
    }

    useEffect(() => {
        if (user !== null && !user?.emailVerified) {
            alert('Kindly verify your email to login');
        }
        if (loading) {
            // maybe trigger a loading screen
            return;
        }
        if (error) {
            alert(error);
        }

        let uid = localStorage.getItem("uid");
        if (user && uid) {
            getUserDetails(user.uid).then((user) => {
                navigate("/dashboard");
            });
        }

        props.actionToggleNavBar(false);
        props.actionToggleSideBar(false);
        props.actionToggleFooter(false);
    }, [user, loading, email, error]);

    return (
        <div className="user-ath-page">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-md-8  text-center">
                        <div className="user-ath-logo">
                            <a href="#">
                                <img width={200} height={200}
                                    src={require('../assets/images/logo_supervisor.PNG')}
                                    srcSet={require('../assets/images/logo_supervisor.PNG')}
                                    alt="icon"
                                />
                            </a>
                        </div>
                        <div className="user-ath-box">
                            <h1>Supervisor Login</h1>
                            <div className="input-item">
                                <TextField id="email" label={translate('Email-Address')} className='input-bordered' onChange={(e) => setEmail(e.target.value)} />
                            </div>
                            <div className="input-item">
                                <TextField id="password" type={'password'} label={translate('Password')} className='input-bordered' onChange={(e) => setPassword(e.target.value)} />
                            </div>
                            {isButtonClicked &&
                                <>
                                    <div className="gaps" />
                                    <img width={80} src={require('../assets/images/loading.gif')} srcSet={require('../assets/images/loading.gif')} alt="loading" />
                                </>
                            }
                            <div className="gaps" />
                            <div className="d-flex justify-content-between align-items-center">
                                <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => validate()}>
                                    {(navigator?.userLanguage === "ja") ? 'ログイン' : 'Log In'}</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        navBar: state.siteLayout.navBar,
    };
};

export default connect(mapStateToProps, {
    actionToggleNavBar,
    actionToggleSideBar,
    actionToggleFooter
})(LoginSupervisor);
